import React from 'react';
import { motion } from 'framer-motion';

/**
 * EmptyState - Componente para exibir quando não há conteúdo
 * 
 * Props:
 * - icon: Componente de ícone Lucide React
 * - title: Título do estado vazio
 * - description: Descrição opcional
 * - action: Elemento React com ação (ex: botão criar)
 */
const EmptyState = ({ icon: Icon, title, description, action }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="relative overflow-hidden"
    >
      {/* Card com glassmorphism */}
      <div className="relative bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-12">
        {/* Gradient overlay sutil */}
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-transparent to-blue-600/5 rounded-2xl"></div>
        
        {/* Conteúdo */}
        <div className="relative text-center">
          {/* Ícone com glow */}
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl blur-2xl opacity-20"></div>
              <div className="relative w-20 h-20 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 rounded-2xl flex items-center justify-center border border-white/10">
                {Icon && <Icon className="w-10 h-10 text-cyan-400" />}
              </div>
            </div>
          </div>

          {/* Título */}
          <h3 className="text-xl font-semibold text-white mb-2">
            {title}
          </h3>

          {/* Descrição */}
          {description && (
            <p className="text-gray-400 mb-6 max-w-md mx-auto">
              {description}
            </p>
          )}

          {/* Ação */}
          {action && (
            <div className="flex justify-center">
              {action}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default EmptyState;
